import { ChangeDetectionStrategy, Component, Input, booleanAttribute } from '@angular/core';

/** Native button semantics and caller styling/labels are preserved. */
@Component({
  selector: 'button[appLoadingButton]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[disabled]': 'loading || disabled', '[attr.aria-busy]': 'loading' },
  template: `
    @if (loading) { <span class="spinner" aria-hidden="true"></span> }
    <ng-content />
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; justify-content: center; gap: .5rem; }
    .spinner { flex: 0 0 auto; width: 1em; height: 1em; border: 2px solid currentColor; border-right-color: transparent; border-radius: 50%; animation: loading-spin .8s linear infinite; }
    @keyframes loading-spin { to { transform: rotate(360deg); } }
    @media (prefers-reduced-motion: reduce) { .spinner { animation: none; } }
  `]
})
export class LoadingButtonComponent {
  @Input({ transform: booleanAttribute }) loading = false;
  @Input({ transform: booleanAttribute }) disabled = false;
}
